import { HIGHLIGHT_MESSAGE } from "@/types/enum/propEnum";
import { MONTH, REPEAT_CYCLE } from "@/types/enum/general";
import { ISSUE_TYPE, TICKET_CONTACT_WAY } from "@/types/enum/general";

const enumDE = {
    pinned: 'Angeheftet',
    new: 'Neu',
    restocked: 'Wieder Verfügbar',
    [HIGHLIGHT_MESSAGE.REDUCED]: 'Im Angebot',
    [HIGHLIGHT_MESSAGE.NOT_IN_STOCK]: 'Mit Lieferzeit',
    [HIGHLIGHT_MESSAGE.PROMOTION]: 'Aktionsartikel',
    issueType: {
        [ISSUE_TYPE.BUG]: 'Bug',
        [ISSUE_TYPE.FEATURE]: 'Feature'
    },
    contactWay: {
        [TICKET_CONTACT_WAY.NONE]: 'Bitte nicht kontaktieren',
        [TICKET_CONTACT_WAY.EMAIL]: 'Email',
        [TICKET_CONTACT_WAY.PHONE]: 'Telefon',
        [TICKET_CONTACT_WAY.EMAIL_OR_PHONE]: 'Email oder Telefon'
    },
    sortDirection: {
        asc: 'Aufsteigend Alphabetisch',
        desc: 'Absteigend Alphabetisch',
        catFilter: 'Nach eigener Kategorie',
        catSupplier: 'Nach Lieferantenkategorie',
        manually: "Manuelle Sortierung"
    },
    weekday: {
        mon: 'Montag',
        tue: 'Dienstag',
        wed: 'Mittwoch',
        thu: 'Donnerstag',
        fri: 'Freitag',
        sat: 'Samstag',
        sun: 'Sonntag'
    },
    repeatCycle: {
        [REPEAT_CYCLE.ONCE]: 'einmalig',
        [REPEAT_CYCLE.WEEK]: 'wöchentlich',
        [REPEAT_CYCLE.MONTH]: 'monatlich',
        appendix: {
            [REPEAT_CYCLE.WEEK]: 'Woche(n)',
            [REPEAT_CYCLE.MONTH]: 'Monat(e)'
        }
    },
    month: {
        [MONTH.JANUARY]: 'Januar',
        [MONTH.FEBRUARY]: 'Februar',
        [MONTH.MARCH]: 'März',
        [MONTH.APRIL]: 'April',
        [MONTH.MAY]: 'Mai',
        [MONTH.JUNE]: 'Juni',
        [MONTH.JULY]: 'Juli',
        [MONTH.AUGUST]: 'August',
        [MONTH.SEPTEMBER]: 'September',
        [MONTH.OCTOBER]: 'Oktober',
        [MONTH.NOVEMBER]: 'November',
        [MONTH.DECEMBER]: 'Dezember',
    }
}

export default enumDE
